import React from 'react';
import { Card } from '~/components/Card';
import { ActivityFeedTabs, HealthHx, PatientAuditNotes, PatientNotes } from '~/components/Patient';
import { PatientReminders } from '~/components/Reminders';
import { ServicesContext } from '~/services';

export interface ActivityFeedProps {
    patient: PatientType;
    reportYear: string;
    tab: string;
    setTab: (x: string) => void;
    setHealthHxVal?: (x: string) => void;
}
export function ActivityFeed({
    patient,
    reportYear,
    setHealthHxVal = () => {},
    tab,
    setTab,
}: ActivityFeedProps) {
    const context = React.useContext(ServicesContext);
    const [tabValue, setTabValue] = React.useState<{ [key: string]: number }>({});

    const setRemindersTab = React.useCallback((num: number) => {
        setTabValue((prev) => ({ ...prev, reminders: num }));
    }, []);
    React.useEffect(() => {
        (async () => {
            const reminders = await context.patient.getReminders(`patient.id=${patient.id}`, false);
            setRemindersTab(reminders.results.length);
        })();
    }, [context.patient, patient.id, reportYear, setRemindersTab]);

    const setHealthHxTab = React.useCallback((num: number) => {
        setTabValue((prev) => ({ ...prev, healthhx: num }));
    }, []);

    return (
        <Card
            id="activity-feed"
            header={<ActivityFeedTabs page={tab} setPage={setTab} tabValue={tabValue} />}
        >
            <HealthHx
                show={tab === 'healthhx'}
                patientId={patient.gmpi}
                setTabValue={setHealthHxTab}
                setHealthHxVal={setHealthHxVal}
            />
            {tab === 'reminders' && (
                <PatientReminders
                    patientId={patient.id}
                    patient={patient}
                    setTabValue={setRemindersTab}
                />
            )}
            {tab === 'notes' && (
                <PatientNotes patient={patient} entityId={patient.id} enableOpenModal />
            )}
            {tab === 'history' && (
                <PatientAuditNotes patient={patient} entityId={patient.id} enableOpenModal />
            )}
        </Card>
    );
}
